export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0031.38dce652.webp";